// Frontend image-proxy helper.
// Routes heavy external images through the free images.weserv.nl Cloudflare
// proxy to transcode them to WebP at a target width, shrinking payloads
// dramatically (often 100–800×) for faster page loads across the site.
//
// • No backend changes, no DB changes.
// • Skips data: / blob: URLs, already-webp URLs, same-origin /placeholder etc.
// • Wraps EVERY other external image by default.

const PROXY = "https://images.weserv.nl/?url=";

// Skip: inline, same-origin, already-tiny, or already-webp.
const SKIP_PATTERNS = [
  /^data:/i,
  /^blob:/i,
  /^\/\//, // protocol-relative — treat as external, don't skip (handled below)
  /^\//,   // same-origin (e.g. /placeholder.jpg)
  /\.webp(\?|$)/i, // already webp
  /images\.weserv\.nl/i, // already proxied
];

export function optimizedImage(src, { width = 800, quality = 75 } = {}) {
  if (!src || typeof src !== "string") return src;
  if (SKIP_PATTERNS.some((rx) => rx.test(src))) return src;
  if (!/^https?:\/\//i.test(src)) return src;

  // weserv wants the URL without the scheme
  const stripped = src.replace(/^https?:\/\//i, "");
  const encoded = encodeURIComponent(stripped);
  return `${PROXY}${encoded}&w=${width}&q=${quality}&output=webp&we&il`;
}

// Convenience wrappers for common sizes used across the site
export const thumb = (src) => optimizedImage(src, { width: 400, quality: 70 });
export const card = (src) => optimizedImage(src, { width: 800, quality: 75 });
export const hero = (src) => optimizedImage(src, { width: 1600, quality: 80 });
